import Vue from 'vue'

Vue.component('alan-fotter', require('./assembly/fotter').default)
Vue.component('alan-login', require('./assembly/login').default)
Vue.component('alan-regist', require('./assembly/regist').default)
Vue.component('alan-zwdd', require('./assembly/zwdd').default)